import { IPage } from '@types'
import Layout from 'components/layouts/Layout'
import ServiceView from 'components/services/ServiceView'
import { getMenus } from 'lib/getMenus'
import { getServiceDetails } from 'lib/getServices'
import { setCacheControl } from 'lib/misc'
import { isAbsent, isNotString, isSame } from 'lib/utils'
import {
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
} from 'next'

import { IGetServiceDetailsResult, IMenuItem } from 'store/api'

export const getServerSideProps = async ({
  req,
  params,
  res,
}: // eslint-disable-next-line @typescript-eslint/require-await
GetServerSidePropsContext) => {
  // Stop from running on client
  const isFirstServerCall = isSame(
    req?.url?.indexOf('/_next/data/'),
    -1
  )

  const emptyProps = {
    serviceDetails: {} as IGetServiceDetailsResult,
    menus: {} as Record<string, IMenuItem[]>,
  }

  if (!isFirstServerCall)
    return {
      props: emptyProps,
    }

  const slug = params?.['slug'] as string | undefined

  if (isNotString(slug))
    return {
      props: emptyProps,
      notFound: true,
    }

  const serviceDetails = await getServiceDetails('ru', slug ?? '')

  if (isAbsent(serviceDetails))
    return {
      props: emptyProps,
      notFound: true,
    }

  setCacheControl(res)

  const menus = await getMenus('ru')

  return {
    props: {
      serviceDetails,
      menus,
    },
  }
}

export type ServicePageProps = Required<
  InferGetServerSidePropsType<typeof getServerSideProps>
>

const ServicePage: IPage<ServicePageProps> = (props) => (
  <ServiceView {...props} />
)

ServicePage.getLayout = (page: { props: ServicePageProps }) => (
  <Layout
    index
    hideBreadcrumbs
    menus={page.props.menus}
    title={page.props?.serviceDetails?.service?.meta.title}
    keywords={page.props?.serviceDetails?.service?.meta.keywords}
    description={
      page.props?.serviceDetails?.service?.meta.description
    }
  >
    {page}
  </Layout>
)

export default ServicePage
